import { render, staticRenderFns } from "./ItemBlankStats.vue?vue&type=template&id=750d7538&scoped=true&"
import script from "./ItemBlankStats.vue?vue&type=script&lang=js&"
export * from "./ItemBlankStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750d7538",
  null
  
)

export default component.exports